/**
 * Latest Robi thread returned by GET /Conversation/{id}/Messages after AI
 * Settings is saved.
 *
 * Web remounts the chat, so the next visit loads on its own. Mobile keeps the
 * bottom-nav Robi screen mounted, so that screen must apply this snapshot or
 * it keeps showing the pre-erase messages.
 */
import { eventBus } from '../platform/eventBus';
import type { ExtendedChatMessage } from '../types/chat';

export const ROBI_CHAT_HISTORY_CLEARED_EVENT = 'ROBI_CHAT_HISTORY_CLEARED';

export interface RobiChatMessagesRefresh {
  epoch: number;
  messages: ExtendedChatMessage[];
}

let historyEpoch = 0;
let latestRefresh: RobiChatMessagesRefresh | null = null;

export const getRobiChatMessagesRefresh = (): RobiChatMessagesRefresh | null =>
  latestRefresh;

/** Publish the Messages response from a successful AI Settings save. */
export const notifyRobiChatMessagesRefreshed = (
  messages: ExtendedChatMessage[],
): void => {
  historyEpoch += 1;
  latestRefresh = { epoch: historyEpoch, messages };
  eventBus.emit(ROBI_CHAT_HISTORY_CLEARED_EVENT, latestRefresh);
};
